import { RouteConfig } from 'vue-router/types/router';
import { CollectionType } from '@/enums/collection-type';

export function makeListRoutes(): RouteConfig[] {
	return [
		{
			name: 'app.sharedlist.list',
			path: '/shared',
			component: () =>
				import(
					/* webpackChunkName: "sharedlistdetails" */ '@/components/shareable-lists/SharedListDetails.vue'
				),
			meta: { tab: 'sharedlist', collectionType: CollectionType.TITLELIST },
		},
	];
}
